{
  "name": "complete-dental-frontend",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:dev:test": "ng serve --c=test --hmr --open",
    "start:dev:acc": "ng serve --c=acc --hmr --open",
    "build": "ng build && npm run sentry:sourcemaps",
    "build:prod": "ng build --configuration production && npm run post-build && npm run sentry:sourcemaps",
    "build:test": "ng build --configuration test && npm run post-build && npm run sentry:sourcemaps",
    "build:accept": "ng build --configuration acc && npm run post-build && npm run sentry:sourcemaps",
    "test": "ng test",
    "test:coverage": "ng test --code-coverage",
    "test:pipeline": "ng test --watch=false --source-map=false --browsers=ChromeHeadlessNoSandbox --karma-config=karma-pipeline.conf.js",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "lint:skip-warnings": "ng lint --quiet",
    "eslint": "eslint 'src/**/*.ts' --quiet",
    "eslint:fix": "eslint 'src/**/*.ts' --fix",
    "prettier": "npx prettier src/app --check",
    "prettier:fix": "npx prettier src/app --write",
    "format": "npm run prettier:fix && ng lint --fix && npm run eslint:fix --quiet",
    "e2e": "ng e2e",
    "cypress": "concurrently \"ng serve\" \"cypress open\"",
    "dockerserve": "ng serve --host localhost --proxy-config proxy.conf.json",
    "stylelint": "stylelint \"**/*.scss\"",
    "post-build": "node ./build/post-build.js",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org emendis-bv --project complete-dental-frontend ./build && sentry-cli sourcemaps upload --org emendis-bv --project complete-dental-frontend ./build",
    "prepare": "husky"
  },
  "pre-commit": [
    "lint",
    "stylelint"
  ],
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.18",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.18",
    "@angular/compiler": "^19.2.18",
    "@angular/core": "^19.2.18",
    "@angular/forms": "^19.2.18",
    "@angular/platform-browser": "^19.2.18",
    "@angular/platform-browser-dynamic": "^19.2.18",
    "@angular/router": "^19.2.18",
    "@angular/service-worker": "^19.2.18",
    "@capturum/api": "^19.0.2",
    "@capturum/auth": "^19.0.1",
    "@capturum/builders": "^19.1.22",
    "@capturum/complete": "^19.0.2",
    "@capturum/formly": "^19.0.1",
    "@capturum/login": "^19.1.2",
    "@capturum/powerbi": "^19.0.3",
    "@capturum/shared": "^19.0.1",
    "@capturum/ui": "^19.3.9",
    "@fortawesome/fontawesome-pro": "^6.4.0",
    "@ngx-formly/core": "^6.3.12",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@ngxs/storage-plugin": "^19.0.0",
    "@ngxs/store": "^19.0.0",
    "@primeng/themes": "^21.0.4",
    "@sentry/angular": "^8.55.0",
    "@sentry/cli": "^2.31.0",
    "autolinker": "^4.1.5",
    "bootstrap": "^5.3.3",
    "file-saver": "^2.0.5",
    "html2canvas": "^1.4.1",
    "jsbarcode": "^3.11.5",
    "jspdf": "^4.0.0",
    "jwt-decode": "^4.0.0",
    "lodash": "^4.17.23",
    "moment": "^2.29.1",
    "ngx-permissions": "^19.0.0",
    "postcss": "^8.3.11",
    "primeicons": "^7.0.0",
    "primeng": "^19.1.4",
    "quill": "^2.0.3",
    "rxjs": "^7.5.5",
    "tslib": "^2.0.0",
    "uuid": "^8.3.2",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.19",
    "@angular-eslint/builder": "19.8.1",
    "@angular-eslint/eslint-plugin": "19.8.1",
    "@angular-eslint/eslint-plugin-template": "19.8.1",
    "@angular-eslint/schematics": "19.8.1",
    "@angular-eslint/template-parser": "19.8.1",
    "@angular/cli": "^19.2.19",
    "@angular/compiler-cli": "^19.2.18",
    "@angularclass/hmr": "^2.1.3",
    "@capturum/linting": "^19.0.0",
    "@commitlint/cli": "^19.8.1",
    "@ngxs/devtools-plugin": "^19.0.0",
    "@types/file-saver": "^2.0.1",
    "@types/jasmine": "~3.6.0",
    "@types/jasminewd2": "~2.0.3",
    "@types/lodash": "^4.14.166",
    "@types/node": "^12.12.55",
    "@typescript-eslint/eslint-plugin": "^8.58.1",
    "@typescript-eslint/parser": "^8.58.1",
    "angular-eslint": "^19.8.1",
    "autoprefixer": "^10.4.7",
    "concurrently": "^5.3.0",
    "cypress": "^15.9.0",
    "eslint": "^9.39.4",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-jasmine": "^4.2.2",
    "eslint-plugin-jsdoc": "^48.11.0",
    "eslint-plugin-prettier": "^5.4.0",
    "eslint-plugin-rxjs-updated": "^1.0.50",
    "eslint-plugin-unused-imports": "^4.1.4",
    "husky": "^9.0.11",
    "jasmine-core": "^4.6.1",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-cli": "^2.0.0",
    "karma-coverage": "^2.2.0",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "karma-spec-reporter": "0.0.33",
    "postcss-scss": "^4.0.9",
    "prettier": "^3.5.3",
    "puppeteer": "^24.35.0",
    "stylelint": "^17.0.0",
    "ts-node": "^10.9.2",
    "typescript": "~5.8.3",
    "typescript-eslint": "^8.58.1"
  }
}
